import { erpAxios } from '..';

const addKomitent = async (data) => {
  const res = await erpAxios.post(`/komitenti/add`, data);
  return res;
};

export default addKomitent;
